import {
  Image,
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";
import React from "react";
import { Discount } from "../store/slices/discountsSlice";
import CloseIcon from "../../assets/images/utils/CloseIcon";
import { Button, useTheme } from "react-native-paper";
import { Feather } from "@expo/vector-icons";
import * as Clipboard from "expo-clipboard";
import { List } from "react-native-paper";
import { FontAwesome } from "@expo/vector-icons";

const voucherImage = require("../../assets/images/discounts/voucher2.jpg");
const isicLogo = require("../../assets/images/discounts/logoisicinternational.png");
const DiscountBanner = ({
  info,
  close,
}: {
  info: Discount;
  close: () => void;
}) => {
  const { colors } = useTheme();
  const copyToClipboard = async (message: string) => {
    await Clipboard.setStringAsync(message);
  };

  return (
    <View style={styles.root}>
      <View style={styles.header}>
        <Image
          source={voucherImage}
          style={styles.voucherImage}
          resizeMode="contain"
        />
        <TouchableOpacity style={styles.closeBtn} onPress={close}>
          <CloseIcon />
        </TouchableOpacity>
      </View>
      <ScrollView style={styles.scrollView}>
        <Text style={styles.howToUseText}>
          {info.voucher == null
            ? `Acesse o site abaixo para ter acesso ao benefício.`
            : `Use este código promocional abaixo no campo de desconto do site do parceiro ISIC ao fazer a compra para ter acesso ao benefício.`}
        </Text>
        {info.voucher && (
          <TouchableOpacity
            style={[styles.voucherBtn, { backgroundColor: colors.primary }]}
            onPress={() => copyToClipboard(info.voucher)}
          >
            <Text style={styles.voucherLabel}>{info.voucher}</Text>
            <Feather
              name="copy"
              size={20}
              color="#fff"
              style={styles.copyIcon}
            />
          </TouchableOpacity>
        )}
        <Text style={styles.howToUseText}>
          Fique atento às regras e exceções para utilização desse benefício no
          site do parceiro ISIC.
        </Text>
        <Button
          mode="text"
          labelStyle={styles.link}
          onPress={() => Linking.openURL(info.link)}
        >
          Acesse o site
        </Button>
        <View>
          <List.Accordion
            title="Observações"
            style={styles.accordion}
            titleStyle={{ color: colors.primary }}
          >
            <Text style={styles.accordionItem}>{info.observations}</Text>
          </List.Accordion>
          <List.Accordion
            title="Sobre"
            style={styles.accordion}
            titleStyle={{ color: colors.primary }}
          >
            <Text style={styles.accordionItem}>{info.about}</Text>
          </List.Accordion>
        </View>
      </ScrollView>

      <View style={styles.footer}>
        <TouchableOpacity
          onPress={() =>
            Linking.openURL("https://www.carteiradoestudante.com.br/")
          }
        >
          <Image
            source={isicLogo}
            style={styles.isicLogo}
            resizeMode="contain"
          />
        </TouchableOpacity>

        <View style={styles.socialIcons}>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://www.instagram.com/carteirinhaisic/")
            }
          >
            <FontAwesome
              name="instagram"
              size={24}
              color={colors.primary}
              style={styles.socialIcon}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://www.facebook.com/MinhaISIC")
            }
          >
            <FontAwesome
              name="facebook"
              size={24}
              color={colors.primary}
              style={styles.socialIcon}
            />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default DiscountBanner;

const styles = StyleSheet.create({
  root: {
    width: "90%",
    marginHorizontal: "5%",
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 5,
    backgroundColor: "#fff",
    height: "90%",
    position: "relative",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginHorizontal: "5%",
    height: 65,
  },
  voucherImage: {
    width: 120,
  },
  closeBtn: {
    backgroundColor: "#fff",
    padding: 5,
    borderRadius: 9,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,

    elevation: 5,
  },
  howToUseText: {
    width: "95%",
    marginHorizontal: "5%",
    paddingHorizontal: 5,
    marginBottom: 6,
    fontSize: 17,
  },
  voucherBtn: {
    alignSelf: "center",
    paddingVertical: 5,
    paddingHorizontal: 9,
    marginVertical: 7,
    borderRadius: 5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  voucherLabel: {
    color: "#fff",
    fontWeight: "700",
    fontSize: 20,
  },
  link: {
    textDecorationLine: "underline",
  },
  copyIcon: {
    marginHorizontal: 10,
  },
  accordionItem: {
    marginHorizontal: 10,
    fontWeight: "400",
    fontSize: 16,
  },
  accordion: { backgroundColor: "#fff" },
  scrollView: { marginBottom: 60 },
  footer: {
    flexDirection: "row",
    width: "95%",
    marginHorizontal: "2.5%",
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderTopColor: "#ddd",
    borderTopWidth: 1,
    paddingVertical: 2,

    marginTop: "auto",
    position: "absolute",
    bottom: 0,
    justifyContent: "space-between",
    alignItems: "center",
  },
  isicLogo: {
    height: 50,
    width: 120,
  },

  socialIcons: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  socialIcon: {
    width: 50,
    height: 50,
    lineHeight: 50,
    borderWidth: 1,
    borderColor: "#e1e8e8",
    borderRadius: 25,
    marginHorizontal: 5,
    textAlign: "center",
  },
});
